import React, {PureComponent} from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import ColorPicker from "./ColorPicker";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import NoSsr from "@material-ui/core/NoSsr";
import isTransparent from "../services/lib/is-transparent";
import {conditionSelector} from "../selectors";
import {changeBgColorForOtherSides} from "../AC/change-bg-color-for-other-sides";
import {setBackgroundColor} from "../AC/set-background-color";
import withErrorBoundary from "../decorators/withErrorBoundary";
import trackEvent from "../../../utils/track-event";
import productSettings from "../services/product-settings";

class BackgroundControl extends PureComponent {
  static propTypes = {
    condition: PropTypes.object,
    changeBgColorForOtherSides: PropTypes.func,
    setBackgroundColor: PropTypes.func
  };
  state = {
    forAllSides: false
  };
  changeBackground = (color, pickerType) => {
    const {r, g, b, a} = color.rgb;
    const rgba = `rgba(${r}, ${g}, ${b}, ${a})`;
    this.props.setBackgroundColor(rgba, this.state.forAllSides);
    if (pickerType === `palette`) {
      trackEvent({
        category: `Editor`,
        action: `Palette color`,
        label: `Background color`
      });
    }
  };
  removeBackground = () => {
    const transparent = `transparent`;
    this.props.setBackgroundColor(transparent, this.state.forAllSides);
  };
  handleCheckboxChange = (e) => {
    const {checked} = e.target;
    this.setState({
      forAllSides: checked
    });
    if (checked) {
      this.props.changeBgColorForOtherSides(this.getColorForBackgroundInput());
    }
  };
  getColorForBackgroundInput() {
    const {
      condition: {design}
    } = this.props;
    if (design && design.background) {
      return design.background;
    }
    return `transparent`;
  }
  isFullPrint() {
    const {
      condition: {product}
    } = this.props;
    const settings = productSettings[product];
    return settings && settings.fullPrint;
  }
  render() {
    const color = this.getColorForBackgroundInput();
    const {forAllSides} = this.state;
    return (
      !this.isFullPrint() && (
        <div className="panel-control">
          <div className="panel-control__title">Фон печатной области</div>
          <div className="panel-control__content">
            <div className="background-control">
              <div className="background-control__content">
                <div className="background-control__pallete">
                  <ColorPicker color={color} onChange={this.changeBackground} />
                </div>
                {!isTransparent(color) && (
                  <div className="background-control__control">
                    <NoSsr>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={forAllSides}
                            onChange={this.handleCheckboxChange}
                            value="checked"
                            color="primary"
                          />
                        }
                        label="Применять ко всем сторонам"
                      />
                    </NoSsr>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )
    );
  }
}

export default connect(
  (state) => ({
    condition: conditionSelector(state)
  }),
  {
    setBackgroundColor,
    changeBgColorForOtherSides
  }
)(withErrorBoundary(BackgroundControl));
